import React from 'react'
import { CircularProgressbar } from '../CircularProgressbar'

import { WarningIcon, SuccessIcon } from '../../../../icons/Icons'

export const AttachmentFilesStatus = props => {
  const { classes } = props

  return (
    <div className={classes.container}>
      {props.status === 'loading' && (
        <>
          <CircularProgressbar value={props.percentUpload} />
          <p>
            {props.loadedFiles.length} of {props.files.length} uploaded
          </p>
        </>
      )}
      {props.status === 'error' && (
        <>
          <WarningIcon />
          <p>
            {props.countErrorFiles}{' '}
            {props.countErrorFiles !== 1 ? 'files' : 'file'} failed to upload
          </p>
        </>
      )}
      {props.status === 'success' && (
        <>
          <SuccessIcon />
          <p>
            {props.loadedFiles.length} of {props.files.length} uploaded
          </p>
        </>
      )}
    </div>
  )
}
